import { Map } from 'immutable';
import {
  TOGGLE_ALERT_ARCHIVE_DESIGN,
  RESET_ALERT_ARCHIVE_DESIGN,
  UPDATE_ARCHIVE_DESIGN_INFO,
  TOGGLE_ALERT_ARCHIVE_MENU,
  RESET_ALERT_ARCHIVE_MENU,
  UPDATE_ARCHIVE_MENU_INFO,
  TOGGLE_ALERT_DOWNLOADING,
  RESET_ALERT_DOWNLOADING,
  UPDATE_DOWNLOADING_INFO,
  UPDATE_DOWNLOADING_COMPLETE,
  TOGGLE_ALERT_COMMON_ERROR,
  RESET_ALERT_COMMON_ERROR,
  UPDATE_COMMON_ERROR_INFO,
} from 'actions/commonAlert';

const archiveDesignInit = {
  open: false,
  designName: '',
  designId: -1,
};

const archiveMenuInit = {
  open: false,
  menuName: '',
  menuId: -1,
};

const downloadingInit = {
  open: false,
  complete: false,
  fileName: '',
};

const commonErrorInit = {
  open: false,
  errorMessage: '',
};

const archiveDesignInitRecord = Map(archiveDesignInit);
const archiveMenuInitRecord = Map(archiveMenuInit);
const downloadingInitRecord = Map(downloadingInit);
const commonErrorInitRecord = Map(commonErrorInit);

const initialValue = {
  archiveDesign: archiveDesignInitRecord,
  archiveMenu: archiveMenuInitRecord,
  downloading: downloadingInitRecord,
  commonError: commonErrorInitRecord,
};

const initialState = Map(initialValue);

const actionsMap = {
  [TOGGLE_ALERT_ARCHIVE_DESIGN]: state => {
    const oldAlert = state.get('archiveDesign');
    const newAlert = oldAlert.set('open', !oldAlert.get('open'));
    return state.set('archiveDesign', newAlert);
  },
  [RESET_ALERT_ARCHIVE_DESIGN]: state => {
    return state.set('archiveDesign', archiveDesignInitRecord);
  },
  [UPDATE_ARCHIVE_DESIGN_INFO]: (state, action) => {
    const oldAlert = state.get('archiveDesign');
    const newAlert = oldAlert.set('designName', action.designName).set('designId', action.designId);
    return state.set('archiveDesign', newAlert);
  },
  [TOGGLE_ALERT_ARCHIVE_MENU]: state => {
    const oldAlert = state.get('archiveMenu');
    const newAlert = oldAlert.set('open', !oldAlert.get('open'));
    return state.set('archiveMenu', newAlert);
  },
  [RESET_ALERT_ARCHIVE_MENU]: state => {
    return state.set('archiveMenu', archiveMenuInitRecord);
  },
  [UPDATE_ARCHIVE_MENU_INFO]: (state, action) => {
    const oldAlert = state.get('archiveMenu');
    const newAlert = oldAlert.set('menuName', action.menuName).set('menuId', action.menuId);
    return state.set('archiveMenu', newAlert);
  },
  [TOGGLE_ALERT_DOWNLOADING]: state => {
    const oldAlert = state.get('downloading');
    const newAlert = oldAlert.set('open', !oldAlert.get('open'));
    return state.set('downloading', newAlert);
  },
  [RESET_ALERT_DOWNLOADING]: state => {
    return state.set('downloading', downloadingInitRecord);
  },
  [UPDATE_DOWNLOADING_INFO]: (state, action) => {
    const oldAlert = state.get('downloading');
    const newAlert = oldAlert.set('fileName', action.fileName);
    return state.set('downloading', newAlert);
  },
  [UPDATE_DOWNLOADING_COMPLETE]: state => {
    const oldAlert = state.get('downloading');
    const newAlert = oldAlert.set('complete', true);
    return state.set('downloading', newAlert);
  },
  [RESET_ALERT_COMMON_ERROR]: state => {
    return state.set('commonError', commonErrorInitRecord);
  },
  [TOGGLE_ALERT_COMMON_ERROR]: state => {
    const oldAlert = state.get('commonError');
    const newAlert = oldAlert.set('open', !oldAlert.get('open'));
    return state.set('commonError', newAlert);
  },
  [UPDATE_COMMON_ERROR_INFO]: (state, action) => {
    const oldAlert = state.get('commonError');
    const newAlert = oldAlert.set('errorMessage', action.errorMessage);
    return state.set('commonError', newAlert);
  },
};

export default function app(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
